export default __webpack_public_path__ + "static/fans-star-coins-illustration-dark-caed01cf22fe63e6dcce90f44baa833b.svg";